import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';




@Component({
  selector: 'oocytequalitydroplet',
  templateUrl: './oocytequalitydroplet.component.html',
  styleUrls: ['./oocytequalitydroplet.component.scss']
})

export class OocytequalitydropletPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public OQACode: any;
  public Owner: string;
  public PatientId: string;
  public ProtocolStart: string;
  public ProtocolEnd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string; 
  public OCCCount: number;
  public DenudedCount: number;
  public AbnormalCount: number;
  public Sign1Name: string;
  public EggSourceData: string;
  public DonorData: string;
  public DonorCode: string;
  //public Status: string;
  //public Morphology: string;
  //public RecordSts: string;
  public Date: Date;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;

  CurrentOocyteMaturityByCycleController2: OocyteMaturityByCycleController[];
  DenudationInfo: OocyteMaturityByCycleController;
  CurrentOocyteMaturityByCycleRequest2: OocyteMaturityByCycleRequest;

  LoadMaturityData2() {
    //alert("ScansData")
    this.CurrentOocyteMaturityByCycleRequest2 = new OocyteMaturityByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentOocyteMaturityByCycleRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteMaturityByCycleController2();
  }

  GetOocyteMaturityByCycleController2() {

    this.CurrentOocyteMaturityByCycleRequest2.ConditionalOperator = 15;
    this.CurrentOocyteMaturityByCycleRequest2.CycleCode = this.TreatmentCycleCode;


    this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest2)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentOocyteMaturityByCycleController2 = this.ApiResData.Result;
          this.DenudationInfo = this.CurrentOocyteMaturityByCycleController2[0];
          this.stopRefreshing();
          this.LoadMaturityData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentOocyteMaturityByCycleController: OocyteMaturityByCycleController[];
  OCCList: OocyteMaturityByCycleController[];
  DenudedList: OocyteMaturityByCycleController[];
  CurrentOocyteMaturityByCycleRequest: OocyteMaturityByCycleRequest;
  TreatmentCycleCode: any;

  LoadMaturityData() {
    //alert("ScansData")
    this.CurrentOocyteMaturityByCycleRequest = new OocyteMaturityByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentOocyteMaturityByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteMaturityByCycleController();
  }

  GetOocyteMaturityByCycleController() {
    this.StartRefreshing();
    //this.CurrentOocyteMaturityByCycleRequest.ConditionalOperator = 10;
    this.CurrentOocyteMaturityByCycleRequest.CycleCode = this.TreatmentCycleCode;


    this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentOocyteMaturityByCycleController = this.ApiResData.Result;
          //this.OCCCount = this.CurrentOocyteMaturityByCycleController;
          this.OCCList = this.ApiResData.Result;
          this.DenudedList = this.ApiResData.Result;
          var list = this.OCCList.filter(
            function (a) {
              return a.OccCount !=0
            });
          this.OCCList = list;
          this.OCCCount = this.OCCList.length;
          var listDenuded = this.DenudedList.filter(
            function (b) {
              return b.DenudedCount !=0 
            });
          this.DenudedList = listDenuded;
          this.DenudedCount = this.DenudedList.length;

          this.stopRefreshing();
          this.LoadMorphologyData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentOocyteMorphologyByCycleController: OocyteMorphologyByCycleController[];
  CurrentOocyteMorphologyByCycleRequest: OocyteMorphologyByCycleRequest;

  LoadMorphologyData() {
    //alert("ScansData")
    this.CurrentOocyteMorphologyByCycleRequest = new OocyteMorphologyByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentOocyteMorphologyByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteMorphologyByCycleController();
  }

  GetOocyteMorphologyByCycleController() {
    this.StartRefreshing();

    this.CurrentOocyteMorphologyByCycleRequest.CycleCode = this.TreatmentCycleCode;

    //alert(this.FormattedCode);
    this.actorservice.GetOocyteMorphologyByCycleController(this.CurrentOocyteMorphologyByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentOocyteMorphologyByCycleController = this.ApiResData.Result;
          this.AbnormalCount = this.CurrentOocyteMorphologyByCycleController.length;
          this.stopRefreshing();
          this.LoadPatients();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(2017, 1, 1);// "1-JAN-2017";
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();// "31-DEC-2018";
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();


    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.ProtocolStart = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEnd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.Sign1Name = this.route.snapshot.paramMap.get('Sign1Name');
    this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
    this.DonorData = this.route.snapshot.paramMap.get('DonorData');
    this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');
    //this.Storage = this.route.snapshot.paramMap.get('Storage');
    //this.Status = this.route.snapshot.paramMap.get('Status');
    //this.Morphology = this.route.snapshot.paramMap.get('Morphology');
    this.LoadMaturityData2();


  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








